const SellersCoverageIncludedStates: Array<string> = ['CO', 'ID', 'IL', 'IN', 'KY', 'MO', 'OH', 'OR', 'UT', 'WA'];

export default SellersCoverageIncludedStates;



// WEBPACK FOOTER //
// ./src/_constants/SellersCoverageIncludedStates.ts